import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorReducerCreator } from '../types';
import { updateBlock } from '../helpers';

const updateBlockImage = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<{ blockId: string; src: string }>) => {
    const { blockId, src } = action.payload;
    updateBlock(state, blockId, (block) => ({ ...block, props: { ...block.props, src } }));
  });

export default updateBlockImage;
